import { createStyles } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    pagination: {
      position: 'absolute',
      width: '60% !important',
      bottom: '15px !important',
      left: '50% !important',
      marginLeft: '-30% !important',
    },
    paginationGallery: {
      bottom: `40px !important`,
    },
    previewCarousel: {
      position: 'relative',
    },
    image: {
      display: 'block',
      height: 250,
      width: '100%',
      objectFit: 'cover',
      outline: 'none',
      userSelect: 'none',
      WebkitUserDrag: 'none',
      WebkitTapHighlightColor: 'transparent',
      '&:focus, &:focus-visible, &:active': {
        outline: 'none',
      },
    },
    imageClickable: {
      cursor: 'pointer',
    },
    fullImage: {
      display: 'block',
      height: 700,
      width: '100%',
      objectFit: 'cover',
    },
    gallery: {
      position: 'absolute',
      right: 5,
      bottom: 6,
      borderRadius: 4,
      padding: '4px 12px',
      color: colors.blue.darkish,
      backgroundColor: colors.blue.light,
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      userSelect: 'none',
      zIndex: 2,
      fontSize: 12,
      fontWeight: 600,
      boxSizing: 'border-box',

      '&:hover': {
        cursor: 'pointer',
      },
    },
    galleryImage: {
      fontSize: 14,
      lineHeight: 1,
      color: colors.blue.darkish,
      display: 'inline-flex',
      alignItems: 'center',
    },
    galleryLabel: {
      fontSize: 12,
      lineHeight: 1,
    },
    dialog: {
      width: '100%',
      maxWidth: 1000,
    },
    headerIcon: {
      fontSize: 18,
      color: colors.grey.lightish,
    },
    headerBtn: {
      minWidth: 38,
      width: 38,
      position: 'absolute',
      right: 5,
      top: 5,
      zIndex: 2,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
      },
    },
    headerBtnSmall: {
      padding: '8px 9px',
    },
  });
